import React, { useState, useEffect } from 'react';
import { Form, FormGroup, Button } from 'reactstrap';
import Axios from 'axios';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faArrowLeft, faTrash } from '@fortawesome/free-solid-svg-icons';

import ImageFileFieldGroup from '../../Common/ImageFileFieldGroup';
import TextFieldGroup from '../../Common/TextFieldGroup';
import CheckboxFieldGroup from '../../Common/CheckboxFieldGroup';
import ProgressIndicator from '../../Common/ProgressIndicator';
import { News } from '../../../Data/Classes';

function NewsEditForm(props) {
    const [isProgress, setIsProgress] = useState(false);
    const [error, setError] = useState({});
    const [news, setNews] = useState(null);

    useEffect(() => {
        setNews(props.news);
    }, [props.news]);

    function onChange(e) {
        setNews({ ...news, [e.target.name]: e.target.value });
    }

    function onCheckedChange(e) {
        setNews({ ...news, [e.target.name]: e.target.checked });
    }

    function setImage(image) {
        setNews({ ...news, background: image });
    }

    function onDeleteClick(e) {
        if (window.confirm("Biztos, hogy törlöd a hírt?\nA művelet nem visszavonható.")) {
            setIsProgress(true);
            Axios.delete(`/admin/news/${news.id}`)
                .then(res => {
                    setIsProgress(false);
                    toast.success("Hír törölve.");
                    window.history.back();
                }, err => {
                    setIsProgress(false);
                    toast.error("A hír törlése sikertelen volt.");
                });
        }
    }

    function onSubmit(e) {
        e.preventDefault();
        setIsProgress(true);
        Axios.post(`/admin/news/${news.id}`,
            new News(news.id,
                news.title,
                news.content,
                news.url,
                news.background,
                news.deleted,
                news.archived))
            .then(res => {
                setIsProgress(false);
                toast.success(`${news.title} elmentve.`);
                window.history.back();
            }, err => {
                setIsProgress(false);
                setError(err.errors);
                toast.error("A hír mentése sikertelen volt.");
            });
    }

    if (isProgress)
        return <ProgressIndicator />;

    if (news)
        return (
            <Form onSubmit={onSubmit} id="newsEditForm">
                <FormGroup>
                    <FormGroup row>
                        <TextFieldGroup className="col-lg"
                            field="title"
                            onChange={onChange}
                            label="Cím"
                            error={error.Title}
                            value={news.title} />
                    </FormGroup>
                    <FormGroup row>
                        <TextFieldGroup className="col-lg"
                            field="content"
                            onChange={onChange}
                            label="Tartalom"
                            error={error.Content}
                            value={news.content} />
                    </FormGroup>
                    <FormGroup row>
                        <ImageFileFieldGroup className="col-lg"
                            field="background"
                            setValue={setImage}
                            label="Háttérkép"
                            error={error.Background}
                            value={news.background}
                            maxWidth={600}
                            maxHeight={350} />
                    </FormGroup>
                    <FormGroup row>
                        <TextFieldGroup className="col-lg"
                            field="url"
                            onChange={onChange}
                            label="URL"
                            error={error.Url}
                            value={news.url || ""} />
                    </FormGroup>
                    <CheckboxFieldGroup
                        field="archived"
                        onChange={onCheckedChange}
                        label="Archivált"
                        error={error.Archived}
                        value={news.archived}
                    />
                </FormGroup>
                {error[""]}
                <Button color="primary" type="submit"><FontAwesomeIcon icon={faCheck} /> Mentés</Button>
                <Button color="primary" type="button" onClick={(e) => window.history.back()}><FontAwesomeIcon icon={faArrowLeft} /> Mégsem</Button>
                <Button color="warning" type="button" onClick={onDeleteClick} className="float-right"><FontAwesomeIcon icon={faTrash} /> Törlés</Button>
            </Form>
        );

    return null;
}

export default NewsEditForm;
